"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookAction = exports.UpsertAction = void 0;
var UpsertAction;
(function (UpsertAction) {
    UpsertAction["INSERT"] = "INSERT";
    UpsertAction["COPY"] = "COPY";
})(UpsertAction = exports.UpsertAction || (exports.UpsertAction = {}));
var BookAction;
(function (BookAction) {
    BookAction["BOOK_CLOSED"] = "BOOK_CLOSED";
    BookAction["BOOK_NEW"] = "BOOK_NEW";
})(BookAction = exports.BookAction || (exports.BookAction = {}));
